import * as React from 'react';
import {
    GridRenderEditCellParams,
    useGridApiContext,
} from '@mui/x-data-grid';
import InputBase, { InputBaseProps } from '@mui/material/InputBase';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { SitesState, selectAllSites } from '../../../slices/sites';
import { Popper, Box, Button, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Paper, Stack, Tooltip, Typography, Menu, Table, TableBody, TableRow, TableCell, TableFooter, TableHead, Divider } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { Site } from '../../../models/interfaces';
import { AssetsState } from '../../../slices/assets';
import { default_project_responsible_value_options } from './project-data-grid';

export const RenderEditCellResponsiblePerson = (props: GridRenderEditCellParams<any, string>) => {
    // const assets_state = useSelector((state: { assets: AssetsState }) => state.assets);
    // const assets = assets_state.assets.filter(asset => asset.asset_type.toLowerCase() === 'employee').sort((a, b) => a.name.localeCompare(b.name));
    const responsible_persons = [...default_project_responsible_value_options].sort((a, b) => a.localeCompare(b));
    const { id, field, value, colDef, hasFocus } = props;
    const [valueState, setValueState] = React.useState(value);
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>();
    const [inputRef, setInputRef] = React.useState<HTMLInputElement | null>(null);
    const apiRef = useGridApiContext();
    const [selected_person, setSelectedPerson] = useState<string | undefined>(props.row.responsible_person);

    React.useLayoutEffect(() => {
        if (hasFocus && inputRef) {
            inputRef.focus();
        }
    }, [hasFocus, inputRef]);

    const handleRef = React.useCallback((el: HTMLElement | null) => {
        setAnchorEl(el);
    }, []);

    const handleChange = React.useCallback<NonNullable<InputBaseProps['onChange']>>(
        (event) => {
            const newValue = event.target.value;
            setValueState(newValue);
            apiRef.current.setEditCellValue(
                { id, field, value: newValue, debounceMs: 200 },
                event,
            );
            setAnchorEl(null);
            apiRef.current.stopCellEditMode({ id: id, field: field, cellToFocusAfter: 'none' });
        },
        [apiRef, field, id],
    );

    return (
        <div style={{ position: 'relative', alignSelf: 'flex-start' }}>
            <div
                ref={handleRef}
                style={{
                    height: 1,
                    width: colDef.computedWidth,
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                }}
            />
            {anchorEl && (
                <Popper open anchorEl={anchorEl} placement='bottom-start'>
                    <Paper elevation={1} sx={{ p: 0, minWidth: colDef.computedWidth }}>
                        <Stack sx={{ p: 0 }} spacing={1}>
                            <Box sx={{ maxHeight: '500px', overflow: 'auto', width: '100%' }}>
                                <Table size='small' stickyHeader={true}>
                                    {/* <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Employee name</TableCell>
                                        </TableRow>
                                    </TableHead> */}
                                    <TableBody>
                                        {
                                            responsible_persons.length > 0 ?
                                                [
                                                    ...responsible_persons.map((responsible_person, index) => {
                                                        return (
                                                            <TableRow
                                                                key={index}
                                                                hover
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleChange({
                                                                        target: { value: `${responsible_person}` },
                                                                    } as React.ChangeEvent<HTMLInputElement>);
                                                                    setSelectedPerson(responsible_person);
                                                                }}
                                                            >
                                                                <TableCell sx={selected_person === responsible_person ? { color: 'blue', fontWeight: 'bold' } : {}}>
                                                                    <Typography>
                                                                        {responsible_person}
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    }),
                                                    <TableRow
                                                        key={'blank'}
                                                        hover
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleChange({
                                                                target: { value: '' },
                                                            } as React.ChangeEvent<HTMLInputElement>);
                                                            setSelectedPerson(undefined);
                                                        }}
                                                    >
                                                        <TableCell sx={selected_person === '' ? { color: 'blue', fontWeight: 'bold' } : {}}>
                                                            <Typography>
                                                                Blank
                                                            </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                ]
                                                :
                                                <TableRow
                                                    key={'blank'}
                                                    hover
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleChange({
                                                            target: { value: '' },
                                                        } as React.ChangeEvent<HTMLInputElement>);
                                                        setSelectedPerson(undefined);
                                                    }}
                                                >
                                                    <TableCell>
                                                        <Typography>
                                                            No employees
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </Box>
                        </Stack>
                    </Paper>
                </Popper>
            )}
        </div>
    );
}